import styled from 'styled-components';

export const AgreementWrapper = styled.div`
  min-height: 100vh;
  background: #f9fafb;
  font-family: 'Inter', sans-serif;
`;

export const Header = styled.header`
  background: #1410DF;
  color: white;
  padding: 60px 20px;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }
`;

export const HeaderContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;
  opacity: 0.9;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const MainContent = styled.main`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;

  @media screen and (max-width: 768px) {
    margin: 24px auto;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 32px;
  border-bottom: 2px solid #e5e7eb;
`;

export const Tab = styled.button`
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ active }) => (active ? "#1410DF" : "#6b7280")};
  border-bottom: 3px solid ${({ active }) => (active ? "#1410DF" : "transparent")};
  margin-bottom: -2px;
  transition: color 0.2s, border-bottom-color 0.2s;

  &:hover {
    color: #1410DF;
  }

  @media screen and (max-width: 768px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

export const ClausesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ClauseItem = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const ClauseTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1410DF;
  margin-bottom: 12px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ClauseText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const LegalSection = styled.div`
  background: #f3f4f6;
  border-radius: 12px;
  padding: 32px 24px;
  margin-top: 40px;

  @media screen and (max-width: 768px) {
    padding: 24px 20px;
    margin-top: 32px;
  }
`;

export const LegalTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 20px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 16px;
  }
`;

export const LegalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const LegalItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LegalLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const LegalValue = styled.span`
  font-size: 15px;
  color: #1f2937;
  font-weight: 500;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const LegalFooter = styled.div`
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #d1d5db;
  text-align: center;

  @media screen and (max-width: 768px) {
    margin-top: 20px;
    padding-top: 16px;
  }
`;

export const LegalFooterText = styled.p`
  font-size: 13px;
  color: #6b7280;
  line-height: 1.6;

  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;
